import React, { Component } from "react";
import { getAppState, withAppState } from "../../state";
import { i18n } from "../../services/i18nService";
import { HeadingStyled, ContainerStyled } from "../../styles/shared-styles";
import { SettingsPageStyled, BlockStyled } from "./styles/Styled";
import { SecondaryMenu, Loading } from "../../services/visualLibraryService";
import { config } from "../../config/config";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { getSdk } from "../../services/sdkService";
import {
  Languages,
  Profile,
  Devices,
  ParentalControl,
  AccountStatus,
  ContactUs,
  Logout,
  ExitApp,
  EVoucher,
  Channels
} from "./subsections";
import { logout } from "../../services/authenticationService";
import { checkVoucherEligiblity } from "../../services/eVoucherEligibilityService";
import { getGlobalButtonFocusPath, getGlobalButtonInfo } from "../../errors/globalButtons";
import { trackPage, trackEvent } from "../../services/analyticsService";
import { isAccessAllowedByParentalLevel } from "../../services/parentalControlService";
import { redirectTo } from "../../services/navigationService";
import { routes } from "../../routes";
import {showForceLogoutError} from "../../services/modalsService";

const PAGE = "settings";
const LOGOUT = "logout";
const EXIT = "exit";
const LANGUAGE = "language";
const EVOUCHER = "eVoucher";
const PARENTAL_CONTROL = "parentalControl";
const CHANNELS = "channels";

let menuItems = null;
let eVoucherData;

function getLanguagesList(locales) {
  const currentLanguage = i18n.getLocale();
  const languages = [];
  for (let key in locales) {
    if (locales.hasOwnProperty(key)) {
      const lang = {
        title: i18n.getWithLocale(`global.languages.${key}`, key),
        languageCode: key,
        active: key === currentLanguage
      };
      if(key=="en")
      {
      languages.push(lang);
}
    }
  }
  return languages;
}

function getLogoutConfirmationOptions() {
  return [
    {
      title: i18n.get("global.no"),
      callback: function() {
        this.lastSelectedSectionIndex && this.props.setFocus(`secondaryItem_${this.lastSelectedSectionIndex}`);
      }
    },
    {
      title: i18n.get("global.yes"),
      callback: async function() {
        const { history, stateActions } = this.props;
        trackEvent(PAGE, "confirm logout", "confirm logout");
        const isResetXToken = true;
        await logout(isResetXToken);
        stateActions.userLoggedOut();
        resetUserSettingsData();
        menuItems = this.generateMenuItems();
        history.push(routes.home);
      }
    }
  ];
}

function getExitConfirmationOptions() {
  return [
    {
      title: i18n.get("global.no"),
      callback: function() {
        this.lastSelectedSectionIndex && this.props.setFocus(`secondaryItem_${this.lastSelectedSectionIndex}`);
      }
    },
    {
      title: i18n.get("global.yes"),
      callback: function() {
        trackEvent(PAGE, "confirm exit app", "confirm exit app");
        resetUserSettingsData();
        getSdk().systemManager.application.exit();
      }
    }
  ];
}

function resetUserSettingsData() {
  eVoucherData = null;
}

function getDefaultSectionContentFocus() {
  return isAccessAllowedByParentalLevel() ? LANGUAGE : PARENTAL_CONTROL;
}

class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
      sectionLoaded: false,
      activeSubsection: getDefaultSectionContentFocus.call(this),
      languageList: getLanguagesList(config.get().locales),
      parentalControlList: config.get().parentalControlList,
      userAccount: null,
      userDevices: null
    };
    this.changeLanguage = this.changeLanguage.bind(this);
    this.changeParentalLevel = this.changeParentalLevel.bind(this);
    this.getMenuItems = this.getMenuItems.bind(this);
    this.changeSubsection = this.changeSubsection.bind(this);
    this.applyConfirmation = this.applyConfirmation.bind(this);
    this.doChangeParentalLevel = this.doChangeParentalLevel.bind(this);
    this.showGlobalModal = this.showGlobalModal.bind(this);
    this.getSectionIndex = this.getSectionIndex.bind(this);
    this.getVoucherSectionIndex = this.getVoucherSectionIndex.bind(this);
    this.voucherHandleEnter = this.voucherHandleEnter.bind(this);
  }

  getSectionIndex(sectionName) {
    return this.getMenuItems().findIndex(item => item.name === sectionName);
  }

  getDefaultMenuItemIndex() {
    return isAccessAllowedByParentalLevel() ? 0 : this.getSectionIndex(PARENTAL_CONTROL);
  }

  getDefaultMenuItemFocused() {
    const { applicationState: { globalModal }, setFocus } = this.props;
    const index = this.getDefaultMenuItemIndex();

    if (!globalModal) {
      setFocus(`secondaryItem_${index}`);
    }
  }

  getDefaultMenuItemSelected() {
    const { history } = this.props;
    const index = this.getDefaultMenuItemIndex();
    this.secondaryMenuSelectedIndex = index;
    history.replace({
      state: {
        secondaryMenuSelectedIndex: index
      }
    });
  }

  async componentDidMount() {
    trackPage.call(this, PAGE);
    if (!eVoucherData && isAccessAllowedByParentalLevel()) {
      eVoucherData = await checkVoucherEligiblity(false);
    }

    menuItems = this.generateMenuItems();
    this.getDefaultMenuItemSelected();
    await this.setState({ isLoaded: true, sectionLoaded: true });
    this.getDefaultMenuItemFocused();
     // Force logout listening
    // showForceLogoutError.call(this);
  }

  componentWillUnmount() {
    eVoucherData = null;
  }

  changeLanguage(language) {
    this.dochangeLanguage(language);
  }

  async dochangeLanguage(language) {
    if (this.props.applicationState.userLocale !== language.languageCode) {
      try {
        await this.props.stateActions.setLocale(language.languageCode);
        // Force logout checks-  if yes , show the popup.
        showForceLogoutError.call(this);
        trackEvent(PAGE, "language change", language.languageCode);
      } catch (e) {
        this.showGlobalModal();
      }
    }
    this.setState(() => {
      menuItems = this.generateMenuItems();
      return { languageList: getLanguagesList(config.get().locales) };
    });
  }

  changeParentalLevel({ key }) {
    const { applicationState: { parentalLevel }, history } = this.props;
    if (parentalLevel !== key) {
      const levels = getSdk().parentalControlLevels;
      if (levels.indexOf(parentalLevel) < levels.indexOf(key)) {
        return history.push({
          pathname: routes.parentalControl,
          state: {
            parentalLevel: key
          }
        });
      }
      this.doChangeParentalLevel(key);
    }
  }

  async doChangeParentalLevel(parentalLevel) {
    try {
      await this.props.stateActions.setParentalLevel(parentalLevel);
      // Force logout checks-  if yes , show the popup.
      showForceLogoutError.call(this);
      trackEvent(PAGE, "parental level change", parentalLevel);
      this.setState(() => {
        menuItems = this.generateMenuItems();
        return { languageList: getLanguagesList(config.get().locales) };
      });
    } catch (e) {
      this.showGlobalModal(() => this.changeParentalLevel({ key: parentalLevel }));
    }
  }

  applyConfirmation(selectedOption) {
    if (selectedOption.callback) {
      selectedOption.callback.call(this);
    }
  }

  getMenuItems() {
    if (menuItems) {
      return menuItems;
    }
    return this.generateMenuItems();
  }

  showGlobalModal(retryCallback) {
    const online = !!getAppState().isOnline;
    const errorText = online
      ? i18n.get("global.errors.genericError")
      : i18n.get("global.errors.internetConnectivity.text");
    this.props.stateActions.showGlobalModal({
      modalText: errorText,
      modalTitle: !online && i18n.get("global.errors.internetConnectivity.title"),
      buttons: [
        {
          ...getGlobalButtonInfo("retry"),
          buttonHandler: async () => {
            this.props.stateActions.hideGlobalModal();
            if (typeof retryCallback === "function") {
              try {
                await retryCallback.call(this);
                this.lastSelectedSectionIndex && this.props.setFocus(`secondaryItem_${this.lastSelectedSectionIndex}`);
              } catch (e) {
                this.showGlobalModal(retryCallback);
              }
            } else {
              this.componentDidMount.bind(this);
            }
          }
        },
        {
          ...getGlobalButtonInfo("close"),
          buttonHandler: () => {
            this.props.stateActions.hideGlobalModal();
            this.props.history.goBack();
          }
        }
      ]
    });
    this.props.setFocus(getGlobalButtonFocusPath("retry"));
  }

  async getProfile() {
    const userAccount = this.state.userAccount || (await getSdk().userManager.get({ avoidCache: true }));
    userAccount && this.setState({ userAccount });
  }

  async getAccountStatus() {
    const userAccount = this.state.userAccount || (await getSdk().userManager.get({ avoidCache: true }));
    userAccount && (userAccount.billing = await getSdk().userManager.getBilling({ avoidCache: true }));
    userAccount && this.setState({ userAccount });
  }

  async getChannels() {
    const channels = this.state.channels || (await getSdk().userManager.getSubscriptionsStatus());
    channels && this.setState({ channels });
  }

  async getDevices() {
    const userDevices = this.state.userDevices || (await getSdk().userManager.getDevices({ avoidCache: true }));
    userDevices && this.setState({ userDevices });
  }

  generateMenuItems() {
    const { applicationState: { parentalLevel, subscriptions } } = this.props;
    const subsectionCallbacks = {
      profile: async () => {
        try {
          await this.getProfile();
        } catch (e) {
          await this.props.stateActions.setForceLogout(e);
          // if Force logout show the popup
          if (!!getAppState().forceLogout) {
            await showForceLogoutError.call(this);
            return;
          }
          this.showGlobalModal(this.getProfile);
        }
      },
      accountStatus: async () => {
        try {
          await this.getAccountStatus();
        } catch (e) {
          await this.props.stateActions.setForceLogout(e);
          // if Force logout show the popup
          if (!!getAppState().forceLogout) {
            await showForceLogoutError.call(this);
            return;
          }
         this.showGlobalModal(this.getAccountStatus);
        }
      },
      channels: async () => {
        try {
          await this.getChannels();
        } catch (e) {
          this.showGlobalModal(this.getChannels);
        }
      },
      devices: async () => {
        try {
          await this.getDevices();
        } catch (e) {
          await this.props.stateActions.setForceLogout(e);
          // if Force logout show the popup
          if (!!getAppState().forceLogout) {
            await showForceLogoutError.call(this);
            return;
          }
          this.showGlobalModal(this.getDevices);
        }
      }
    };
    const userLogged = getAppState().userLogged;
    const shouldItemShow = item => {
      switch (item.name) {
        case CHANNELS:
          return (subscriptions && !!subscriptions.length) || false;
        default:
          return true;
      }
    };
    const show = item => (!item.onlyLoggedIn || item.onlyLoggedIn === userLogged) && shouldItemShow(item);

    menuItems = config
      .get()
      .settingsSubsections.filter(item => (!eVoucherData ? item.name !== EVOUCHER : item))
      .filter(
        item =>
          this.state.parentalControlList.indexOf(item.minimumParentalLevel) <=
          this.state.parentalControlList.indexOf(parentalLevel)
      );

    menuItems.forEach(item => {
      const languageKey = `pages.settings.menu.${item.name}`;
      const languageValue = i18n.get(`pages.settings.menu.${item.name}`);
      item.tagTitle = languageKey !== languageValue ? languageValue : i18n.get(`global.${item.name}`);
      item.beforeSubsectionEnter = subsectionCallbacks[item.name];
      item.show = show(item);
    });
    return menuItems.filter(item => (item.show !== undefined ? item.show : true));
  }

  async changeSubsection(index) {
    this.secondaryMenuSelectedIndex = index;
    this.setState({ sectionLoaded: false });
    const selectedSection = Object.values(this.getMenuItems())[index];
    this.lastSelectedSectionIndex = index;
    selectedSection.beforeSubsectionEnter && (await selectedSection.beforeSubsectionEnter());
    this.setState({ activeSubsection: selectedSection.name, sectionLoaded: true });
    trackPage.call(this, PAGE);
    (selectedSection.name === LOGOUT || selectedSection.name === EXIT) && this.props.setFocus("selectorItem_0");
  }

  getSubsectionLayout(subsection) {
    const subsections = {
      language: <Languages languagesList={this.state.languageList} onItemSelected={this.changeLanguage} />,
      profile: this.state.userAccount && <Profile userAccount={this.state.userAccount} />,
      parentalControl: (
        <ParentalControl
          parentalControlList={this.state.parentalControlList}
          onItemSelected={this.changeParentalLevel}
        />
      ),
      accountStatus: this.state.userAccount && <AccountStatus userAccount={this.state.userAccount} />,
      channels: <Channels channels={this.state.channels} />,
      devices: this.state.userDevices && <Devices devices={this.state.userDevices} />,
      contactUs: <ContactUs />,
      logout: <Logout confirmationOptions={getLogoutConfirmationOptions()} onItemSelected={this.applyConfirmation} />,
      exit: <ExitApp confirmationOptions={getExitConfirmationOptions()} onItemSelected={this.applyConfirmation} />,
      ...(!!eVoucherData && {
        eVoucher: (
          <EVoucher
            enterHandler={this.voucherHandleEnter}
            sectionItemFocused={this.lastSelectedSectionIndex || this.getVoucherSectionIndex()}
          />
        )
      })
    };
    return subsections[subsection];
  }

  getVoucherSectionIndex() {
    return this.getSectionIndex(EVOUCHER);
  }

  voucherHandleEnter() {
    const userLogged = getAppState().userLogged;
    const eventAction = userLogged ? "settings_user_selects_startnow" : "settings_user_selects_joinnow";
    const path = userLogged ? routes.redeem : routes.signup;
    trackEvent("signup", eventAction);
    redirectTo.call(this, path);
  }

  render() {
    return (
      <SettingsPageStyled>
        {this.state.isLoaded ? (
          <>
            <HeadingStyled rank={1} text={i18n.get("pages.settings.title")} />
            <ContainerStyled>
              <BlockStyled>
                <SecondaryMenu
                  items={this.getMenuItems()}
                  onClick={this.changeSubsection}
                  currentFocus={this.props.applicationState.currentFocus}
                  secondaryMenuSelectedIndex={this.secondaryMenuSelectedIndex}
                />
              </BlockStyled>
              <BlockStyled>
                {this.state.sectionLoaded ? (
                  this.getSubsectionLayout(this.state.activeSubsection)
                ) : (
                  <Loading overlay opacity="0" />
                )}
              </BlockStyled>
            </ContainerStyled>
          </>
        ) : (
          <Loading overlay />
        )}
      </SettingsPageStyled>
    );
  }
}

export default withAppState(withSubtheme(Settings));
